import React from "react";
import { Routes, Route } from "react-router-dom";
import SupportLayout from "./SupportLayout";
import SupportHome from "./SupportHome";
import SupportPatientPage from "./SupportPatientPage";
import SupportMrnPage from "./SupportMrnPage";
import SupportDoctorPage from "./SupportDoctorPage";
import SupportTicketPage from "./SupportTicketPage";

const Support = ({ setAuth, setUserOrg }) => (
  <Routes>
    <Route element={<SupportLayout setAuth={setAuth} setUserOrg={setUserOrg} />}>
      <Route index element={<SupportHome />} />
      <Route path="patient/:patientId" element={<SupportPatientPage />} />
      <Route path="mrn/:mrn" element={<SupportMrnPage />} />
      <Route path="doctor/:doctorId" element={<SupportDoctorPage />} />
      <Route path="ticket/:ticketId" element={<SupportTicketPage />} />
    </Route>
  </Routes>
);

export default Support;
